function SectionBackgroundScroll() {
	this.build();
}

SectionBackgroundScroll.prototype.build = function () {
	const section = document.querySelector('.section-background-scroll .row');
	const background = document.querySelector('.section-background-scroll .background');
	if (background) {
		gsap.to(background, {
			opacity: 1,
			ease: 'none',
			scrollTrigger: {
				trigger: section,
				start: 'top top',
				end: 'bottom center',
				scrub: true
			}
		});
	}

	const cover = document.querySelector('.section-background-scroll .cover');
	if (cover) {
		gsap.to(cover, {
			scale: 1.2,
			ease: 'none',
			scrollTrigger: {
				trigger: section,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true
			}
		});
	}
};
